import React from "react";
import { Box, Typography } from "@mui/material";
import { OcCurrency } from "oc/components";

interface MyCafeteriaVbkApplicationTableRowProps {
  benefit: string;
  months: string;
  numberOfMonths: number;
  amount: number;
  valueOfBenefit: number;
  cost: number;
  isMobile: boolean;
}

export const MyCafeteriaVbkApplicationTableRow: React.FC<
  MyCafeteriaVbkApplicationTableRowProps
> = ({
  benefit,
  months,
  numberOfMonths,
  amount,
  valueOfBenefit,
  cost,
  isMobile,
}) => {
  const columnWidth = "156px";
  return (
    <Box
      width={isMobile ? "max-content" : "auto"}
      height="48px"
      paddingLeft="8px"
      display="flex"
      flexDirection="row"
      alignItems="center"
      style={{ borderBottom: "1px solid #5E6366" }}
    >
      <Box
        flexGrow={1}
        textAlign="left"
        padding="0px 8px"
        style={{ minWidth: "180px" }}
      >
        <Typography variant="body2">{benefit}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body2">{months}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body2">{numberOfMonths}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body2">{OcCurrency({ value: amount })}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body2">{OcCurrency({ value: cost })}</Typography>
      </Box>
      <Box width={columnWidth} textAlign="right" padding="0px 8px">
        <Typography variant="body2">
          {OcCurrency({ value: valueOfBenefit })}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyCafeteriaVbkApplicationTableRow;
